import "./App.css";
import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import fidusLogo from "./Assets/FidusLogo.png";
import "./nav.css";
import ContactUs from "./ContactPages/ContactUs.jsx";
import RequestDemo from "./ContactPages/RequestDemo.jsx";
import "./ContactPages/contactPage.css";

import { Link, Route, Routes, useLocation } from "react-router-dom";
import Home from "./Home.jsx";
import Avaition from "./domains/Avaition.jsx";
import Healthcare from "./domains/Healthcare.jsx";
import Logistics from "./domains/Logistics.jsx";
import Retail from "./domains/Retail.jsx";
import Construction from "./domains/Construction.jsx";
import LMS from "./Products/LMS.jsx";
import Examiner from "./Products/Examiner.jsx";
import CCD from "./Products/CCD.jsx";
import Footer from "./Footer.jsx";
import { useStateContext } from "./contexts/ContextProvider.js";
import Demo from "./Demo.jsx";
import Blog from "./HomeComponents/Blog.jsx";
import About from "./About.jsx";
import Products from "./Products.jsx";
import Services from "./Services.jsx";

function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
}

function App() {
  const { showContact, setShowContact, handleShowContact } = useStateContext();
  const [showRequestDemo, setShowRequestDemo] = useState(false);

  const [show, setShow] = useState(false);

  const [showDesktopMenu, setShowDesktopMenu] = useState(false);

  const location = useLocation();

  const amountScrolled = 200;

  const [show2, setShow2] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > amountScrolled) {
        setShow2(true);
      } else {
        setShow2(false);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleShowRequestDemo = () => setShowRequestDemo(!showRequestDemo);

  const width = useWindowWidth();

  return (
    <div className="App">
      {width > 992 ? (
        <>
          <div className={showDesktopMenu ? "sidebar active" : "sidebar"}>
            <div className="close">
              <button
                className="btn btn-small"
                title="close-menu"
                aria-label="close-menu"
                aria-labelledby="close-menu"
                onClick={() => setShowDesktopMenu(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  class="bi bi-x"
                  viewBox="0 0 16 16"
                >
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                </svg>
              </button>
            </div>
            <div className="list">
              <div className="item">
                <a
                  href="/#thefidusdifference"
                  aria-label="Fidus Difference"
                  onClick={() => setShowDesktopMenu(false)}
                >
                  <span>Fidus Difference</span>
                </a>
              </div>
              <div className="item">
                <a
                  href="/#our-journey"
                  aria-label="Our Journey"
                  onClick={() => setShowDesktopMenu(false)}
                >
                  <span>Our Journey</span>
                </a>
              </div>
              <div className="item">
                <a
                  href="/#ourexpertise"
                  aria-label="Our Expertise"
                  onClick={() => setShowDesktopMenu(false)}
                >
                  <span>Our Expertise</span>
                </a>
              </div>
              <div className="item">
                <a
                  href="/#why-choose-us"
                  aria-label="Why Choose Us"
                  onClick={() => setShowDesktopMenu(false)}
                >
                  <span>Why Choose Us</span>
                </a>
              </div>
              <div className="item">
                <a
                  href="/#who-we-are"
                  aria-label="Who We Are"
                  onClick={() => setShowDesktopMenu(false)}
                >
                  <span>Who We Are</span>
                </a>
              </div>
              <div className="item">
                <a
                  href="/#what-we-do"
                  aria-label="What We Like"
                  onClick={() => setShowDesktopMenu(false)}
                >
                  <span>What We Do</span>
                </a>
              </div>
              <div className="item">
                <a
                  href="/#what-we-like"
                  aria-label="What We Like"
                  onClick={() => setShowDesktopMenu(false)}
                >
                  <span>What We Like</span>
                </a>
              </div>
              <div className="item">
                <a
                  href="/#training-modules"
                  aria-label="Training Module at a Glance"
                  onClick={() => setShowDesktopMenu(false)}
                >
                  <span>Training Module at a Glance</span>
                </a>
              </div>
              <div className="item">
                <a
                  href="/#our-domain"
                  aria-label="Our Domain"
                  onClick={() => setShowDesktopMenu(false)}
                >
                  <span>Our Domain</span>
                </a>
              </div>
              <div className="item">
                <a
                  href="/#our-products"
                  aria-label="Our Products"
                  onClick={() => setShowDesktopMenu(false)}
                >
                  <span>Our Products</span>
                </a>
              </div>
              <div className="item">
                <a
                  href="/#blogs"
                  aria-label="Our Blogs"
                  onClick={() => setShowDesktopMenu(false)}
                >
                  <span>Blogs</span>
                </a>
              </div>
            </div>
          </div>
        </>
      ) : null}

      {width < 992 ? (
        <>
          <div
            className={show ? "modal-overlay active" : "modal-overlay"}
            onClick={() => {
              setShow(false);
            }}
          >
            <div className="" onClick={(e) => e.stopPropagation()}>
              <div
                className={show ? "mobilenavbar show" : "mobilenavbar"}
                id="responsive-navbar-nav"
              >
                <Nav>
                  <Link
                    className={
                      location.pathname === "/" ? "nav-link active" : "nav-link"
                    }
                    to={"/"}
                  >
                    <span>
                      {" "}
                      <svg
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M4.53645 12.327C4.36582 12.7389 4.33329 12.9494 4.33329 13V21.6686C4.33329 22.2656 4.81702 22.75 5.41663 22.75H8.66663V16.25C8.66663 15.0533 9.63668 14.0833 10.8333 14.0833H15.1666C16.3633 14.0833 17.3333 15.0533 17.3333 16.25V22.75H20.5833C21.1829 22.75 21.6666 22.2656 21.6666 21.6686V13C21.6666 12.9494 21.6341 12.7389 21.4635 12.327C21.305 11.9444 21.0646 11.4753 20.7509 10.9444C20.1244 9.88411 19.2454 8.64498 18.2615 7.46435C17.2753 6.28103 16.2109 5.18882 15.221 4.40324C14.7263 4.01054 14.2714 3.71158 13.8726 3.51476C13.4647 3.3135 13.1777 3.24999 13 3.24999C12.8222 3.24999 12.5352 3.3135 12.1273 3.51476C11.7286 3.71158 11.2737 4.01054 10.7789 4.40324C9.78906 5.18882 8.72457 6.28103 7.73845 7.46435C6.7546 8.64498 5.87554 9.88411 5.24904 10.9444C4.93528 11.4753 4.69497 11.9444 4.53645 12.327ZM11.1685 1.57181C11.7382 1.29066 12.3652 1.08333 13 1.08333C13.6347 1.08333 14.2617 1.29066 14.8315 1.57181C15.4102 1.85741 15.9964 2.25247 16.5679 2.70612C17.711 3.61325 18.8808 4.82312 19.9259 6.0773C20.9734 7.33417 21.9224 8.66796 22.6163 9.84209C22.9626 10.4283 23.2556 10.9917 23.4652 11.4978C23.6627 11.9746 23.8333 12.5089 23.8333 13V21.6686C23.8333 23.4649 22.377 24.9166 20.5833 24.9166H17.3333C16.1367 24.9166 15.1666 23.9466 15.1666 22.75V16.25H10.8333V22.75C10.8333 23.9466 9.86325 24.9166 8.66663 24.9166H5.41663C3.623 24.9166 2.16663 23.4649 2.16663 21.6686V13C2.16663 12.5089 2.33723 11.9746 2.53476 11.4978C2.74441 10.9917 3.03729 10.4283 3.3837 9.84209C4.07751 8.66796 5.02657 7.33417 6.07397 6.0773C7.11911 4.82312 8.28899 3.61325 9.43197 2.70612C10.0036 2.25247 10.5898 1.85741 11.1685 1.57181Z"
                          fill="none"
                        />
                      </svg>
                    </span>
                  </Link>
                  <Link
                    className={
                      location.pathname === "/about"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to={"/about"}
                  >
                    About Fidus
                  </Link>
                  <Link
                    className={
                      location.pathname === "/products"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to={"/products"}
                  >
                    Our Products
                  </Link>
                  <Link
                    className={
                      location.pathname === "/services"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    to={"/services"}
                  >
                    Our Services
                  </Link>
                  {/* <Link
                className={
                  location.pathname === "/team" ? "nav-link active" : "nav-link"
                }
                to={"/team"}
              >
                Our Team
              </Link> */}
                </Nav>
              </div>
            </div>
          </div>
        </>
      ) : null}

      <div className="contact-pages">
        <div className="contactUs-main-cont">
          {showContact && (
            <ContactUs
              showContact={showContact}
              setShowContact={setShowContact}
            />
          )}
        </div>
        <div>
          {showRequestDemo && (
            <RequestDemo
              showRequestDemo={showRequestDemo}
              setShowRequestDemo={setShowRequestDemo}
            />
          )}
        </div>
      </div>

      <div className="main-container">
        <div className="nav-main">
          <Navbar
            collapseOnSelect
            expand="lg"
            className="bg-body-tertiary"
            id="navvbar"
            fixed="top"
          >
            <Container>
              <Navbar.Brand href={location.pathname === "/" ? "#home" : "/"}>
                <img
                  src={fidusLogo}
                  className="logo d-inline-block align-top"
                  alt="Fidus India"
                />
              </Navbar.Brand>
              <div className="d-flex gap-2">
                <Nav>
                  <button
                    className="btn menu-btn"
                    title="Contact us"
                    aria-label="Contact us"
                    aria-labelledby="Contact us"
                    onClick={handleShowContact}
                  >
                    <span className="grey-circle toggleContactUs">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 26 26"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M25.5325 22.5266C24.73 24.9654 21.5857 26.1817 19.3393 25.9789C16.2713 25.7016 12.9329 24.0743 10.3988 22.282C6.67385 19.6474 3.18465 15.5719 1.15145 11.2473C-0.285488 8.19138 -0.607884 4.43421 1.52932 1.64875C2.31972 0.619146 3.17425 0.0692594 4.45865 0.00512604C6.24051 -0.0815406 6.49012 0.937836 7.10198 2.52557C7.55785 3.7129 8.16624 4.92407 8.50598 6.15474C9.14211 8.4514 6.91825 8.54739 6.63745 10.4246C6.46238 11.6085 7.89758 13.1961 8.54585 14.0402C9.81638 15.6938 11.3434 17.1201 13.0664 18.2051C14.0526 18.8274 15.6456 19.9487 16.7757 19.3299C18.516 18.3766 18.3513 15.4422 20.7849 16.4354C22.045 16.9485 23.2653 17.6889 24.4682 18.3372C26.3281 19.3373 26.2414 20.3738 25.5325 22.5266C26.0629 20.9181 25.0021 24.1351 25.5325 22.5266Z"
                          fill="var(--primary-color)"
                        />
                      </svg>
                    </span>
                  </button>

                  <div className="position-relative cursor-pointer">
                    <div id="google_translate_element"></div>
                    <button
                      className="btn menu-btn"
                      title="Translate"
                      aria-label="Translate"
                      aria-labelledby="Translate"
                    >
                      <span className="grey-circle grey-circle-2 toggleContactUs toggleLang">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 29 30"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.04297 10.168L13.293 17.418"
                            stroke="var(--primary-color)"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M4.83203 17.418L12.082 10.168L14.4987 6.54297"
                            stroke="var(--primary-color)"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M2.41797 6.54297H16.918"
                            stroke="var(--primary-color)"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M8.45703 2.91797H9.66536"
                            stroke="var(--primary-color)"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M26.5833 27.0833L20.5417 15L14.5 27.0833"
                            stroke="var(--primary-color)"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M16.918 22.25H24.168"
                            stroke="var(--primary-color)"
                            strokeWidth="3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>

                        <svg
                          width="15"
                          height="10"
                          viewBox="0 0 13 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.731602 0.901437C0.373644 1.2594 0.373644 1.83984 0.731602 2.1978L5.21621 6.67792C5.93221 7.39328 7.09253 7.39301 7.80826 6.67737L12.2911 2.1945C12.6491 1.83654 12.6491 1.2561 12.2911 0.898128C11.9331 0.540142 11.3527 0.540142 10.9947 0.898128L7.15789 4.73495C6.79993 5.093 6.2195 5.093 5.86154 4.73495L2.02795 0.901437C1.66999 0.543451 1.08965 0.543451 0.731602 0.901437Z"
                            fill="var(--primary-color)"
                          />
                        </svg>
                      </span>
                    </button>
                  </div>

                  <button
                    className="request-demo-btn d-none d-lg-block"
                    type="button"
                    title="Request a Demo"
                    aria-label="Request a Demo"
                    aria-labelledby="Request a Demo"
                    onClick={handleShowRequestDemo}
                  >
                    Request a Demo
                  </button>
                </Nav>
                {location.pathname === "/" ? (<>
                 <button
                  className="btn menu-btn"
                  title="menu"
                  aria-label="menu"
                  aria-labelledby="menu"
                  onClick={() => setShowDesktopMenu(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    fill="var(--primary-color)"
                    class="bi bi-list"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
                    />
                  </svg>
                </button></>) : null}
               
              </div>
            </Container>
          </Navbar>
        </div>

        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/aviation" exact element={<Avaition />} />
          <Route path="/healthcare" exact element={<Healthcare />} />
          <Route path="/logistics" exact element={<Logistics />} />
          <Route path="/retail" exact element={<Retail />} />
          <Route path="/construction" exact element={<Construction />} />
          <Route path="/lms" exact element={<LMS />} />
          <Route path="/examiner" exact element={<Examiner />} />
          <Route path="/custom-course-development" exact element={<CCD />} />
          <Route path="/demo" exact element={<Demo />} />
          <Route path="/blog" exact element={<Blog />} />
          <Route path="/about" exact element={<About />} />
          <Route path="/products" exact element={<Products />} />
          <Route path="/services" exact element={<Services />} />
          {/* <Route
            path="/team"
            exact
            element={<OurTeam hideOnMobile={false} />}
          /> */}
        </Routes>
        <Footer />
        <button
          className={`back-to-top${show2 ? " show" : ""}`}
          onClick={handleClick}
          title="mobile-menu"
          aria-label="mobile-menu"
          aria-labelledby="mobile-menu"
          type="button"
        ></button>
      </div>
    </div>
  );
}

export default App;
